import type { ValueOf } from 'type-fest';

export const CLOSE_PETITION_ERROR_MAP = {
	GRAPHQL_ERROR: 'starter_dashboard_close_petition_graphql_error',
	NO_DATA_ERROR: 'starter_dashboard_close_petition_data_not_found',
	UNAUTHENTICATED_ERROR: 'starter_dashboard_close_petition_unauthenticated',
	UNKNOWN_ERROR: 'starter_dashboard_close_petition_unknown_error',
} as const;

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export const closePetitionErrors = Object.values(CLOSE_PETITION_ERROR_MAP) as ReadonlyArray<
	ValueOf<typeof CLOSE_PETITION_ERROR_MAP>
>;

export type ClosePetitionErrorCodes = (typeof closePetitionErrors)[number];
